import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { string, bool } = proptypes;

export const DropdownItem = (
  {
    attributeValue = null,
    swatchGuid = null,
    isDisabled = false
  }
) => {
  return (
    <div className="sui-flex sui-items-center">
      {swatchGuid && (
        <div className="sui-flex-shrink-0 sui-mr-3">
          <img
            alt={attributeValue || ''}
            title={attributeValue || ''}
            src={swatchGuid}
            className="sui-w-8 sui-h-8 sui-object-cover"
            width="30"
            height="30"
          />
        </div>
      )}
      <Typography
        variant="body-base"
        color={isDisabled ? 'inactive' : 'primary'}
      >
        {attributeValue}
      </Typography>
    </div>
  );
};

DropdownItem.displayName = 'DropdownItem';

DropdownItem.propTypes = {
  attributeValue: string,
  swatchGuid: string,
  isDisabled: bool,
};